import { connect } from 'react-redux';
import { withProps, withHandlers, compose } from 'recompose';

import BlockTimeForm from './blockTimeForm';
import { editBlockTime, deleteBlockTime } from '../../barbers/actions';
import { getAll } from '../../barbers/selector';
import { formatTimeFromDate } from '../../../common/helpers/times';
import { CONFIRMATION_REQUIRED_STATUS } from '../../constants';
import confirmModal from '../../../common/confirmModal';

const dayOffToBlockTime = dayOff => ({
  barberId: dayOff.barberId,
  day: dayOff.start,
  startTime: formatTimeFromDate(dayOff.start, dayOff.timezone),
  endTime: formatTimeFromDate(dayOff.end, dayOff.timezone),
  id: dayOff.id,
  isRecurring: dayOff.isRecurring,
  showUpdateAllRecurring: dayOff.isRecurring,
  updateAllRecurring: dayOff.isRecurring,
  description: dayOff.description,
});

const mapStateToProps = (state, props) => ({
  barbers: getAll(state),
  initialValues: dayOffToBlockTime(props.dayOff),
});

const mapDispatchToProps = {
  modifyBlockTime: editBlockTime,
  deleteBlockTime,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    save: props => data => new Promise((resolve, reject) =>
      props.modifyBlockTime(data).then(resolve).catch((err) => {
        if (err.status === CONFIRMATION_REQUIRED_STATUS) {
          return confirmModal(
            {
              title: 'Heads up!',
              message: err.message,
              type: 'yesno',
              confirmButtonText: 'Yes',
              negativeButtonText: 'No',
            },
            () => props.modifyBlockTime(data, true).then(resolve),
            () => resolve(null),
          );
        }

        return reject(err);
      })
    ),
    afterSave: props => (data) => {
      if (!data) {
        return null;
      }

      return props.afterSave(data);
    },
  }),
  withProps(() => ({
    isEditing: true,
  })),
)(BlockTimeForm);
